import table from '@/components/Table';
import upload from '@/components/Upload';
import wangEditor from '@/components/WangEditor';
import modal from '@/components/Modal';
import Audit from '@/components/Audit';
import ImagePreview from '@/components/ImagePreview';
import DicSelect from '@/components/DicSelect';

export default {
    install(Vue) {
        Vue.component('qTable', table);
        Vue.component('qUpload', upload);
        Vue.component('qEditor', wangEditor);
        Vue.component('qModal', modal);
        Vue.component('qAudit', Audit);
        Vue.component('qImagePreview', ImagePreview);
        Vue.component('qDic', DicSelect);
    }
}


// WEBPACK FOOTER //
// ./src/Common/globalComponents.js